import React from 'react';

import { Button } from '@trqk/components';
import { locale } from '@trqk/utils';

/**
 * A RenderContent component for a Toast which informs the user they are trying to use more than
 * their current max number of detections, and shows a button they can click to upgrade their
 * subscription.
 * @param props {ToastRenderContentProps<{}>}
 */
export const MaxDetectionsExceeded = ({
    input,
    remove,
}: ToastRenderContentProps<{
    showTrackSpecificMessage: boolean;
    maxDetections: number;
}>): JSX.Element => (
        <div style={{ width: 350 }} className="px-2 text-sm">
            <div className="flex justify-between items-start ">
                <div className="mr-4">
                    <div className="font-bold text-highlight-orange tracking-wider">
                        {
                            locale.enUS.MANAGE_DETECTIONS.TOASTS
                                .MAX_DETECTIONS_EXCEEDED.TITLE
                        }
                    </div>
                    <div className="my-4">
                        {
                            locale.enUS.MANAGE_DETECTIONS.TOASTS
                                .MAX_DETECTIONS_EXCEEDED.DESCRIPTION.PART_1
                        }
                        &nbsp;
                        <span className="font-semibold">
                            {
                                locale.enUS.MANAGE_DETECTIONS.TOASTS
                                    .MAX_DETECTIONS_EXCEEDED.DESCRIPTION.PART_2
                            }
                            &nbsp;
                            {input?.maxDetections ?? 0}
                            &nbsp;
                            {
                                locale.enUS.MANAGE_DETECTIONS.TOASTS
                                    .MAX_DETECTIONS_EXCEEDED.DESCRIPTION.PART_3
                            }
                            .
                        </span>
                    </div>
                    <div className="mt-4 mb-8">
                        {
                            locale.enUS.MANAGE_DETECTIONS.TOASTS
                                .MAX_DETECTIONS_EXCEEDED.DESCRIPTION.PART_4
                        }
                    </div>
                    {/*
                        TODO: link to Account page with CTA like "Upgrade Now!" when subscription
                        management is implemented
                        https://app.asana.com/0/1161035310203426/1195249056507529
                    */}
                    <div className="flex justify-end">
                        <Button
                            color="danger-primary-light-bg"
                            autoWidth={true}
                            handleClick={(): void => {
                                remove({
                                    canceled: true,
                                    success: true,
                                });
                            }}
                        >
                            <div className="mx-8">
                                {
                                    locale.enUS.MANAGE_DETECTIONS.TOASTS
                                        .MAX_DETECTIONS_EXCEEDED.BUTTONS.OK
                                }
                            </div>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
